"use client"

import "bootstrap/dist/css/bootstrap.css";
import "@soprisapps/schoolblocks/src/scss/_error.scss";
import '@soprisapps/schoolblocks/src/scss/_reset.scss';
import ErrorPage from "@soprisapps/components/pages/ErrorPage";
import ClientTransitionWrapper from "@soprisapps/components/stores/ClientTransitionWrapper";

export default function Error({error, reset}) {
    return <ClientTransitionWrapper initialLookupData={{}}>
        <ErrorPage />
    </ClientTransitionWrapper>
}